<template>
  <div class="container">
    <div class="overlay-image" v-if="showPassportImage">
      <img src="../assets/svg/Passport@2x.svg" alt="Passport Image" />
    </div>
    <p>
      Please upload a clear image of the
      <span
        class="blue-text"
        @mouseover="showPassportImage = true"
        @mouseleave="showPassportImage = false"
        >first page of your passport</span
      >
      in jpg/png files with a size less than 1Mb
    </p>
  </div>
</template>

<script>
export default {
  name: "PassportUploadPrompt",
  data() {
    return {
      showPassportImage: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/color";
.blue-text {
  color: $link-color;
  cursor: pointer;
}
.container {
  position: relative;
  .overlay-image {
    width: 250px;
    padding: 33px 45px 33px 45px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);
    position: absolute;
    bottom: 40px;
    left: 160px;
    z-index: 1000;
    img {
      width: 100%;
      height: 100%;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PassportUploadPrompt.vue